module.exports = __webpack_public_path__ + "static/media/pricing-calculator.31547063.png";